/**
 * The doors an install lands on, per platform (`components/InstallAppBanner.vue`
 * — the offer a phone browser gets on app.torik.ai; the owner's ask,
 * 2026-10-05).
 *
 * Both doors are TESTING doors for now, because neither store has a public
 * listing yet (checked 2026-10-05: the Play details page answers 404 to the
 * public, and the App Store holds no Torik — only the iOS build's TestFlight
 * door). The owner handed over the Play internal-testing opt-in on 2026-10-05;
 * the TestFlight join link and, later, the public store links are one-line
 * replacements here.
 *
 * An empty string means "no door for this platform": the banner hides for
 * that platform rather than promising an install nobody can make.
 */
export const APP_STORE_LINKS: { android: string; ios: string } = {
  android: 'https://play.google.com/apps/internaltest/4701173200837135016',
  ios: '',
}
